import { useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { ImportPreviewTableRow } from 'entities/ui/model/absence';

/**
@hook получение строки с пересечением периода 
*/

export const useIntervalErrorRow = (id: number): ImportPreviewTableRow | undefined => {
  const intervalErrors = useAppSelector(uiModel.Absence.selectors.getIntervalErrors);
  const row = intervalErrors.find(item => id === item.tableId);
  const invalidRows = intervalErrors.filter(
    item =>
      row?.personnelNumber === item.personnelNumber && row.startedAt <= item.endedAt && row.endedAt >= item.startedAt,
  );
  if (invalidRows.length === 2) {
    return invalidRows.find(item => id !== item.tableId);
  }
};
